export default (props, vars) =>
  vars?.['useform3']?.['formState'].isSubmitSuccessful;
